import { defineStore } from 'pinia';
import { useRoute } from 'vue-router';

export const useRouteStore = defineStore('routeStore', {
  state: () => ({
    route: useRoute(),
  }),

  getters: {
    params: (state) => {
      return state.route.params;
    },
    pageName: (state) => {
      return state.route.name;
    },
  },
});
